import { Injectable } from '@angular/core';
import {HttpService, QueryModel} from '../http/http.service';
import {catchError, map, Observable} from 'rxjs';
import {iResponse, iResponseList} from '../../models/response/response.model';
import {CreateRecipeModel, RecipeModel, UpdateRecipeModel} from '../../models/recipe/recipe.model';

@Injectable({
  providedIn: 'root'
})
export class RecipeService extends HttpService{

    createRecipe(recipeData: CreateRecipeModel): Observable<iResponse<any>> {
        return this.post('prescriptions', recipeData).pipe(
            map((response: iResponse<any>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        );
    }

    getRecipes(query: QueryModel): Observable<iResponseList<RecipeModel>> {
        return this.get('prescriptions', query).pipe(
            map((response: iResponseList<RecipeModel>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        );
    }

    saveRecipe(recipeId: string): Observable<iResponse<any>> {
        return this.put(`prescriptions/${recipeId}/save`, {}).pipe(
            map((response: iResponse<any>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        );
    }

    updateRecipe(recipeId: string, recipeData: UpdateRecipeModel): Observable<iResponse<any>> {
        return this.put(`prescriptions/${recipeId}`, recipeData).pipe(
            map((response: iResponse<any>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        );
    }

    // for following prescriptions
    copyPrescription(recipeId: string): Observable<iResponse<RecipeModel>> {
        return this.put(`prescriptions/${recipeId}/copy`, {}).pipe(
            map((response: iResponse<RecipeModel>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        );
    }

    downloadPrescription(recipeId: string, query: QueryModel): void {
        this.download(`prescriptions/${recipeId}/download`,'rezept.pdf', 'application/pdf',  query);
    }

    notifyForDoctorReview(prescriptionId: string): Observable<any> {
        return this.get(`prescriptions/${prescriptionId}/review`).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        );
    }

    previewPrescription(prescriptionId: string, query: QueryModel): Observable<any> {
        return this.get(`prescriptions/${prescriptionId}/preview`, query).pipe(
            map((response: any) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        );
    }

}
